import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ShippingMethods from '../Cart/ShippingMethods';

import { basicMsg, msg } from '../../../actions/swal_msg';

import { getTitle } from '../../../helpers/admin/productHelper';
import { formatCheckoutOrder } from '../../../helpers/shop/shopHelper';

import { checkoutOrderData, loadCart } from '../../../actions/shop';
import { getFullOrder, processOrder } from '../../../actions/payment';
import { checkOrderCoupon, saveClientData } from '../../../actions/checkout';

import { shippingAddressFormValidator } from '../../../validators/ShippingAddressValidator';

import {
    Box, Divider, Grid, List, ListItem,
    ListItemText, Typography, Stack
} from "@mui/material";
import PaymentIcon from '@mui/icons-material/Payment';
import LoadingButton from '@mui/lab/LoadingButton';

const TuOrden = ({
    page, setPage, fill,
    shippingValues, billingValues,
    paymentValues, setPaymentValues
}) => {
    const dispatch = useDispatch();
    const isMounted = useRef(true);

    const {
        cart: {
            item, // productos
            summary, // resumen
            item_summary, // tu orden
            cart_promotion,
            coupon, // cupón aplicado
        }, // carrito
        shipping: {
            methods: { // métodos de envío
                selected // seleccionado
            }
        }
    } = useSelector(state => state.shop);
    
    const { name } = coupon; // nombre cupón
    const { _id, cost } = selected; // ID y costo de método de envío
    const { promos_discount, discount, total } = summary;
    // correo de cliente
    const { email } = shippingValues;
    // datos de pago
    const { payment_method } = paymentValues;

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const getPaymentURL = (method, init_point, payment_url, redirect_url) => {
        if (method === 'MercadoPago')
            return init_point;
        else if (method === 'PayPal')
            return payment_url;
        else if (method === 'OpenPay')
            return redirect_url;
    };

    const validate = async () => {
        setLoading(true);
        if (page === 0) { // page 0 = información personal
            if (_id) {
                if (shippingAddressFormValidator(shippingValues, billingValues)) {
                    if (coupon && coupon.name) { // hay cupón aplicado
                        const CouponCheck = await checkOrderCoupon({
                            email, name,
                            _id: coupon._id,
                            use_method: coupon.use_method,
                            source: coupon.source
                        });
                        if (CouponCheck.status) { // cupón disponible y aplicado
                            goToPage(); // ir a métodos de pago
                            saveClientData(shippingValues);
                            return;
                        } else { // cupón no está disponible
                            const { resp: { cart_msg, ...cartData } } = CouponCheck;
                            if (cart_msg.includes('refresh-cart')) // se recuperó carrito
                                dispatch(loadCart(cartData)); // se recarga carrito sin cupón
                            
                            saveClientData(shippingValues);
                        }
                    } else {
                        goToPage(); // ir a métodos de pago
                        saveClientData(shippingValues);
                        return;
                    }
                }
            } else basicMsg('Seleccione método de envío');
        } else if (page === 1) { // page 1 = métodos de pago
            if (
                payment_method.length > 2 &&
                payment_method.length <= 30
            ) {
                const OrderModel = await getFullOrder({
                    addressValues: shippingValues, billingValues,
                    summary, shipping: selected, cart: item,
                    couponData: coupon
                }, payment_method);
                const req = await processOrder(OrderModel, payment_method);
                if (req.status) { // pedido registrado
                    const {
                        order_id, order_num,
                        paypal_id, payment_url, id, init_point, redirect_url
                    } = req.resp;
                    const { payment: { nefro_reference } } = OrderModel;
                    // enlace de pago de método elegido
                    const order_payment_url = getPaymentURL(payment_method, init_point, payment_url, redirect_url);
                    // guardar pedido pendiente (para caso de que cliente abandone checkout)
                    dispatch(checkoutOrderData(
                        formatCheckoutOrder(
                            OrderModel, order_id, order_num, payment_method, order_payment_url
                        )
                    ));
                    if (payment_method === 'PayPal')
                        setPaymentValues(e => ({
                            ...e, order_num,
                            paypal_id, order_id, nefro_reference
                        }));
                    else if (payment_method === 'MercadoPago')
                        setPaymentValues(e => ({
                            ...e, order_num,
                            preference_id: id
                        }));
                    else if (payment_method === 'OpenPay')
                        setPaymentValues(e => ({
                            ...e, order_num,
                            redirect_url
                        }));
                    // else if (payment_method === 'EvoPayments') {
                    //     const { session_id } = req.resp;
                    //     setPaymentValues({
                    //         ...paymentValues,
                    //         session_id
                    //     });
                    // }
                    goToPage();
                    return;
                } else { // actualizar carrito (en caso de promociones expiradas)
                    if (req.cartData)
                        dispatch(loadCart(req.cartData));
                    if (req.reviewCart && isMounted.current) {
                        setPage(0);
                        window.scrollTo({ top: 0 });
                    }
                }
            } else
                msg('info', 'Checkout',
                'No ha seleccionado método de pago');
        }
        
        if (isMounted.current) setLoading(false);
    };

    const goToPage = () => {
        setPage(e => e + 1);
        window.scrollTo({
            top: 0,
        });
    };
    
    return (
        <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
            <Box sx={{ p: 3 }} className="total-form-fixed">
                <Typography variant='h5'
                    sx={{ fontWeight: '600', textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
                    Tu orden
                </Typography>
                <List disablePadding>
                    {
                        item_summary.map((e, i) =>
                            <ListItem sx={{ px: 0 }} key={i}>
                                <ListItemText
                                    primary={`${
                                        getTitle(e.title, e.variant_title)
                                    } (${e.quantity})`}
                                    secondary={
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary">
                                            { e.promo_text !== '' ? e.promo_text : '' }
                                        </Typography>
                                    }
                                />
                                {
                                    (
                                        e.discount_by_promo !== 0 ||
                                        e.discount_by_coupon !== 0
                                    ) ?
                                        <Stack spacing={1}>
                                            <Typography sx={{ color: '#000', fontWeight: '600', textDecoration: 'line-through' }}
                                                variant="body2">
                                                ${ e.item_subtotal }
                                            </Typography>
                                            <Typography sx={{ color: '#229954', fontWeight: '600' }} variant="body2">
                                                ${ e.item_total }
                                            </Typography>
                                        </Stack>
                                    :
                                        <Typography sx={{ color: '#229954', fontWeight: '600' }} variant="body2">
                                            ${ e.item_subtotal }
                                        </Typography>
                                }
                            </ListItem>
                        )
                    }
                    <Divider sx={{ my: 2 }} />
                    {
                        name !== '' && (
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary={ name } secondary={
                                    coupon._class === 'order_discount' ?
                                        `Cupón ${
                                            coupon.discount.type === 'fixed' ?
                                                `$${coupon.discount._value}`
                                            :
                                                `${coupon.discount._value}%`
                                        }`
                                    :
                                        `Cupón Envío Gratis`
                                    }
                                />
                                <Typography sx={{ color: '#C0392B', fontWeight: '600' }} variant="body2">
                                    {
                                        coupon._class === 'order_discount' ?
                                            `- $${
discount
                                            }`
                                        :
                                            `¡Tiene envío gratis!`
                                    }
                                </Typography>
                            </ListItem>
                        )
                    }

                    {
                        promos_discount !== 0 &&
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary="Descuento por promociones" secondary={
                                    `${ cart_promotion.filter(e => e.active).length } activa(s)`
                                } />
                                <Typography sx={{ color: '#C0392B', fontWeight: '600' }}
                                    variant="body2">
                                    - ${ promos_discount }
                                </Typography>
                            </ListItem>
                    }

                    {
                        _id &&
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary="Envío" />
                                <Typography sx={{ color: '#229954', fontWeight: '600' }}
                                    variant="body2">
                                    { cost === 0 ? 'Gratis' : `$${cost}` }
                                </Typography>
                            </ListItem>
                    }
                    {
                        _id &&
                            <ListItem sx={{ px: 0 }}>
                                <ListItemText primary="Total + envío" />
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                    ${ total }
                                </Typography>
                            </ListItem>
                    }
                </List>
                    
                <ShippingMethods
                    display={
                        (selected && selected._id)
                        ? false : true
                    }
                    fill={ fill }
                />
                
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mb: 1 }}>
                    <LoadingButton
                        sx={{ height: '50px', width: '100%' }}
                        endIcon={<PaymentIcon />}
                        loading={loading}
                        loadingPosition="end"
                        variant="contained"
                        onClick={ validate }>
                        continuar
                    </LoadingButton>
                </Box>
                <Typography
                    sx={{ fontSize: '13px' }}>
                    El monto total que se muestra es el precio final con IVA y costos de envío incluido.
                </Typography>
            </Box>
        </Grid>
    );
};

export default TuOrden;
